import { render, staticRenderFns } from "./MenuDialogs.vue?vue&type=template&id=2d7bcfc7&"
import script from "./MenuDialogs.vue?vue&type=script&lang=js&"
export * from "./MenuDialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports